<div class="row company-info" *ngIf="companyInfo">
    <p>
        <ins>Address</ins><br>
        <span>{{ companyInfo.address }}</span><br>
        <span *ngFor="let hour of companyInfo.hours">{{ hour }}<br></span>
    </p>
    <p>
        <ins>Email</ins><br>
        <span *ngFor="let email of companyInfo.emails">
            <a [href]="'mailto:' + email">{{ email }}</a><br>
        </span>
    </p>
    <p>
        <ins>Phone</ins><br>
        <span *ngFor="let phone of companyInfo.phones">
            <a [href]="'tel:' + phone">{{ phone }}</a><br>
        </span>
    </p>
</div>